import Vue from 'vue';

const userStore = {
  state: {
    loggedIn: false,
    token: null,
    tokenExpired: false,
  },
  logIn(token) {
    const path = `${location.hostname}`;

    this.state.loggedIn = true;
    this.state.token = token;

    Vue.cookie.set('token', token, { expires: 1, domain: path });
  },
  logOut(tokenExpired) {
    const path = `${location.hostname}`;

    if (tokenExpired) {
      this.state.tokenExpired = true;
    }
    this.state.loggedIn = false;
    this.state.token = null;
    Vue.cookie.delete('token', { expires: 1, domain: path });
  },
  isLoggedIn() {
    return this.state.loggedIn;
  },
};

export default userStore;



// WEBPACK FOOTER //
// ./src/store/userAuthStore.js